import { render, staticRenderFns } from "./InternacoesPanel.vue?vue&type=template&id=7e3df6b0&"
import script from "./InternacoesPanel.vue?vue&type=script&lang=ts&"
export * from "./InternacoesPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CBox: require('@chakra-ui/vue').CBox, CAccordionPanel: require('@chakra-ui/vue').CAccordionPanel})
